import React from 'react';
import {SelectBox} from 'src/design/atoms/SelectBox';
import {useListEntityNameSelectOptionsQuery} from 'src/redux/queries/auditLog';
import type {ISelectOption} from 'src/types/Form';

export interface EntityTypeSelectProps {
  value: string;
  onChange: (value: string) => void;
}

export const EntityTypeSelect: React.FC<EntityTypeSelectProps> = ({
  value,
  onChange,
}) => {
  const {data: entityTypes, isLoading} = useListEntityNameSelectOptionsQuery();

  const handleEntityTypeChange = (value: string): void => {
    onChange(value);
  };

  const entityTypeOptions: ISelectOption[] =
    entityTypes?.data?.map(option => ({
      id: option.label ?? '',
      label: option.label?.splitUppercase() ?? '',
    })) ?? [];

  return (
    <SelectBox
      label="Entity Type"
      options={entityTypeOptions}
      value={value}
      disabled={isLoading}
      onSelectChangeCallback={handleEntityTypeChange}
    />
  );
};
